import React, { useState, useCallback } from 'react'
import { ActiveChatContext } from './ActiveChatContextDef'

interface ActiveChatProviderProps {
  children: React.ReactNode
}

export function ActiveChatProvider({ children }: ActiveChatProviderProps): React.ReactElement {
  const [activeChatNodeId, setActiveChatNodeId] = useState<string | null>(null)

  const openChat = useCallback((nodeId: string) => {
    setActiveChatNodeId(nodeId)
  }, [])

  const closeChat = useCallback(() => {
    setActiveChatNodeId(null)
  }, [])

  return (
    <ActiveChatContext.Provider value={{ activeChatNodeId, openChat, closeChat }}>
      {children}
    </ActiveChatContext.Provider>
  )
}
